import {Box, CircularProgress} from '@mui/material';
import {useEffect, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';
import socket, {IResponse} from '@sockets';
import ChannelHeader from './ChannelHeader';
import IChannel, {IMessage} from './IChannel';
import {Virtuoso} from 'react-virtuoso';
import Message from './Message';


export default function Channel() {
	const location = useLocation();
	const {channelId} = useParams();
	const [channel, setChannel] = useState<IChannel | undefined>(location.state?.channel);
	const [messages, setMessages] = useState<IMessage[]>([]);
	const [loading, setLoading] = useState(false);
	
	
	useEffect(() => {
		if (!channel) {
			socket.emit('network:channel', channelId, (data: IResponse<IChannel>) => {
				if (data.success) {
					setChannel(data.result);
				}
			});
		}
		loadMoreMessage();
		socket.on('channel:message', (data: { channelId: number, message: IMessage }) => {
			if (Number(channelId) === data.channelId) {
				setMessages([...messages, data.message]);
			}
		});
		return () => {
			socket.off('channel:message');
			socket.emit('network:leave');
		};
	}, []);
	
	const loadMoreMessage = () => {
		const messageRequest: { channelId: number, before?: Date } = {
			channelId: Number(channelId)
		};
		if (messages.length) {
			messageRequest.before = messages[0].createdAt;
		}
		setLoading(true);
		socket.emit('network:channel_messages', messageRequest, (data: IResponse<IMessage[]>) => {
			setLoading(false);
			if (data.success) {
				const newMessages = data.result.map(message => {
					message.createdAt = new Date(message.createdAt);
					return message;
				});
				setMessages([...newMessages.reverse(), ...messages]);
			}
		});
	};
	
	return (
		<div className="flex flex-col h-full">
			<ChannelHeader channel={channel}/>
			<Box className="grow px-4"
			     sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'grey.50' : 'background.paper'}}>
				{loading && <div className="absolute z-10 left-1/2"><CircularProgress size={12}/></div>}
				{
					messages.length ? <Virtuoso
						data={messages}
						initialTopMostItemIndex={500}
						alignToBottom={true}
						startReached={loadMoreMessage}
						itemContent={(index, message) => <Message message={message}/>}
					/> : <></>
				}
			</Box>
		</div>
	);
}
